const CATEGORIES = [
  { key: 'buildings', label: 'Buildings' },
  { key: 'fleet', label: 'Fleet' },
  { key: 'defense', label: 'Defense' },
  { key: 'research', label: 'Research' },
];

function PlanetCategoryTabs({ active, onChange }) {
  return (
    <div className="flex border-b border-gray-500 mb-2">
      {CATEGORIES.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          className={
            'px-4 py-2 text-sm font-semibold ' +
            (active === key
              ? 'text-white border-b-2 border-blue-500'
              : 'text-gray-400 hover:text-gray-200')
          }
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default PlanetCategoryTabs;
